import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, MessageSquare } from 'lucide-react';
export function Mechanism() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-149">
      <div className="max-w-4xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-blue rounded-3xl p-8 md:p-12 text-white shadow-soft-lg relative overflow-hidden" data-id="element-151">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-152"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-yellow/20 rounded-full blur-2xl translate-y-1/2 -translate-x-1/4" data-id="element-153"></div>

          <div className="relative z-10" data-id="element-154">
            <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-1.5 rounded-full text-sm font-semibold mb-6 backdrop-blur-sm" data-id="element-155">
              <Sparkles size={16} className="text-brand-yellow" data-id="element-156" />
              La Solución
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-157">
              Presentamos el Método S.O.S.
            </h2>
            <p className="text-lg md:text-xl text-blue-100 mb-10 leading-relaxed max-w-2xl" data-id="element-158">
              No te enseñamos a programar; te enseñamos a conversar. A través
              del{' '}
              <span className="font-bold text-white" data-id="element-159">
                "Sándwich de Prompts"
              </span>
              , aprenderás a dar instrucciones tan claras a la IA que obtendrás
              recursos educativos, planes de clase y explicaciones magistrales
              en segundos, manteniendo siempre el control humano.
            </p>

            <div className="grid sm:grid-cols-3 gap-4 mb-8" data-id="element-160">
              {[{
              letter: 'S',
              title: 'Simple',
              desc: 'Sin jerga técnica.'
            }, {
              letter: 'O',
              title: 'Operativo',
              desc: 'Listo para usar hoy.'
            }, {
              letter: 'S',
              title: 'Seguro',
              desc: 'Con control ético.'
            }].map((item, i) => <div key={i} className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20" data-id="element-161">
                  <div className="text-3xl font-black text-brand-yellow mb-2" data-id="element-162">
                    {item.letter}
                  </div>
                  <h3 className="font-bold text-lg mb-1" data-id="element-163">{item.title}</h3>
                  <p className="text-blue-100 text-sm" data-id="element-164">{item.desc}</p>
                </div>)}
            </div>

            <div className="bg-white text-brand-dark rounded-2xl p-6 flex items-start gap-4 shadow-lg" data-id="element-165">
              <div className="bg-brand-orange/10 p-3 rounded-xl shrink-0" data-id="element-166">
                <MessageSquare className="text-brand-orange" size={24} data-id="element-167" />
              </div>
              <div data-id="element-168">
                <h4 className="font-bold text-lg mb-1" data-id="element-169">
                  El Sándwich de Prompts
                </h4>
                <p className="text-brand-text text-sm leading-relaxed" data-id="element-170">
                  Una estructura probada de 3 capas para hablar con la IA:
                  Contexto, Tarea y Formato. Obtén resultados perfectos a la
                  primera, sin frustraciones.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}